import request from '@/utils/request';
import userDashboardMockupData from './mockup/userDashBoardData.json';
import popupMockupData from './mockup/popupData.json';
import systemBlock from './mockup/systemBlock.json';

// 공지사항 Top1
// gs.song 2023.07.24 channelDispyCd 파라미터 추가
export function getNoticeBoard(data) {
	return request({
		url: '/notice/top10',
		method: 'post',
		data,
	});
}

// Biz 인기상품 조회
export function getPopularGGoodsList(data) {
	return request({
		url: '/main/searchPopularGGoodsList',
		method: 'post',
		data,
	});
}

// Biz 찬스 조회
export function getChanceGGoodsList(data) {
	return request({
		url: '/main/getBizChanceGGoodsList',
		method: 'post',
		data,
	});
}

// Biz 테마 조회
export function getThemeList(data) {
	return request({
		url: '/main/getBizThemeList',
		method: 'post',
		data,
	});
}

// Biz 테마 상품 조회
export function getThemeGGoodsList(data) {
	return request({
		url: '/main/getBizThemeGGoodsList',
		method: 'post',
		data,
	});
}

// 배너 목록 조회
export function getBannerList(data) {
	return request({
		url: '/main/getAllBannerList',
		method: 'post',
		data,
	});
}

// 장바구니 건수 조회
export function getCartItemCount(data) {
	return request({
		url: '/ggoods/cartItemCount',
		method: 'post',
		data,
	});
}

// 팝업 목록 조회
export function getPopupList(data) {
	return request({
		url: '/v2/popup/list',
		method: 'post',
		data,
	});
}

// 시스템 차단 공지 조회
export function getSystemBlock(data) {
	return request({
		url: '/v2/blockMgmt/list',
		method: 'post',
		data,
	});
}

// 레벨업 팝업 확인 저장
export function showLevelUpPopup(data) {
	return request({
		url: '/popup/save',
		method: 'post',
		data,
	});
}

// 로그인 하지 않고 RM 체크
export function getPossibleNotLogin(data) {
	return request({
		url: '/order/possibleNotLogin',
		method: 'post',
		data,
	});
}

// 약관 동의 팝업 목록 조회
export function getTermsPopupList(data) {
	return request({
		url: '/terms/popup/list',
		method: 'post',
		data,
	});
}

// 약관 동의 이력 저장
export function agreeTermsPopup(data) {
	return request({
		url: '/terms/popup/agree',
		method: 'post',
		data,
	});
}
